//=====================================================
//　G004：患者情報入力
//=====================================================

import { useHistory } from "react-router-dom";
import { ContentsBox } from "../../common/ContentsBox";
import { BtnSubmit } from "../../common/BtnSubmit";
import { ReservationFlow, ProcessName } from "../../common/ReservationFlow";
import { ReservationInfo } from "../../common/ReservationInfo";
import { ContentsTitle } from "../../common/ContentsTitle";
import { BtnReturn } from "../../common/BtnReturn";
import { FormBox } from "../../common/FormBox";
import { TxtTel } from "../../common/TxtTel";
import { TxtEmail } from "../../common/TxtEmail";
import { TxtName } from "../../common/TxtName";
import { SltBirthday } from "../../common/SltBirthday";
import { NotesMail } from "../../common/NotesMail";
import { ChkRuleAgree } from "../../common/ChkRuleAgree";
import { useContext, useState, useEffect } from "react";
import { CtxClinicInfo, CtxClinicSystemInfo, CtxNewReservation, CtxSystemErr } from "../../utils/Contexts";
import { useForm } from "react-hook-form";
import { IFDataNewReservation } from "../../utils/UseNewReservation";
import { getApiData } from "../../utils/CallApi";
import { AxiosResponse } from "axios";
import { ConstMsg } from "../../utils/ConstMsg";
import { MsgBoxErr } from "../../common/MsgBoxErr";
import { LoadingBox } from "../../common/LoadingBox";
import { useAuth } from "../../utils/UseAuth";

export function G004(){
    const [errmess, setErrmess] = useState("");
    const history = useHistory();
    const cserr = useContext(CtxSystemErr);
    const cnr = useContext(CtxNewReservation);
    const cci = useContext(CtxClinicInfo);
    const ccsi = useContext(CtxClinicSystemInfo);
    const uf = useForm({reValidateMode: "onSubmit"});
    const ua = useAuth();

    // ブラウザバックで表示させない処理
    useEffect(function(){
        //タイトル追加処理
        if(cci.data.name){
            document.title = cci.data.name + " | Web予約 - 患者情報入力";
        }else{
            document.title = process.env.REACT_APP_DEFAULT_CLININC_NAME + " | Web予約 - 患者情報入力";
        }
        
        // マウントフラグ
        let isMounted = true;
        
        // アンマウント時はstate(history)を更新しないようにする
        if(isMounted){
            // 完了データの場合、マイページ、トップ画面へ遷移
            if(cnr.data.done){
                if(ua.isLoggedIn()){
                    history.push('/mypage');
                } else {
                    history.push('/');
                }
            }
        }

        // cleanup関数(Unmount時の処理)
        return () => {
            // マウントオフ
            isMounted = false;
        }
        // アンマウント時にのみ一回だけ実行したいため第2引数指定なし。
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [loadingDone, setLoadingDone] = useState(true);

    //入力項目名
    const FORM_NAME_LAST = "input-name-last";
    const FORM_NAME_FIRST = "input-name-first";
    const FORM_NAME_PHONE = "input-phone-number";
    const FORM_NAME_EMAIL = "input-email";
    const FORM_NAME_BIRTHDAY_YEAR = "input-year";
    const FORM_NAME_BIRTHDAY_MONTH = "input-month";
    const FORM_NAME_BIRTHDAY_DAY = "input-day";
    const FORM_NAME_RULE_AGREE = "input-rule-agree";

    //バリデーション通過時処理
    function FormSubmit() {

        setLoadingDone(false);

        //患者存在確認
        let apiUrl = `/c/${cci.data.id}/patients/count`;
        let apiParams = {
            params: {
                firstName: uf.getValues(FORM_NAME_FIRST),
                lastName: uf.getValues(FORM_NAME_LAST),
                tel: uf.getValues(FORM_NAME_PHONE),
                email: uf.getValues(FORM_NAME_EMAIL) ? uf.getValues(FORM_NAME_EMAIL) : "",
                year: uf.getValues(FORM_NAME_BIRTHDAY_YEAR) ? uf.getValues(FORM_NAME_BIRTHDAY_YEAR) : "",
                month: uf.getValues(FORM_NAME_BIRTHDAY_MONTH) ? uf.getValues(FORM_NAME_BIRTHDAY_MONTH) : "",
                day: uf.getValues(FORM_NAME_BIRTHDAY_DAY) ? uf.getValues(FORM_NAME_BIRTHDAY_DAY) : "",
            }
        };

        getApiData(
            apiUrl,
            apiParams,
            function(res:AxiosResponse<any>) {
                if (res?.status) {
                    if (res.status === 200) {
                        if (res.data.count === 0) {
                            setErrmess("");
                            let params:IFDataNewReservation = {
                                name: uf.getValues(FORM_NAME_LAST) + " " + uf.getValues(FORM_NAME_FIRST), 
                                tel: uf.getValues(FORM_NAME_PHONE), 
                            }
                            if (ccsi.data.display.patientEmail){
                                params.email =uf.getValues(FORM_NAME_EMAIL);
                            }
                            if (ccsi.data.display.birthday){
                                params.birthday = uf.getValues(FORM_NAME_BIRTHDAY_YEAR) + "年" + 
                                                    uf.getValues(FORM_NAME_BIRTHDAY_MONTH) + "月" + 
                                                    uf.getValues(FORM_NAME_BIRTHDAY_DAY) + "日";
                            }
                            cnr.update(params);
                            history.push("/reservation/symptoms");
                        } else {
                            setErrmess(ConstMsg.EG0040010);
                        }
                    } else if (res.status === 400 ){
                        setErrmess(res.data.message);
                    } else if (res.status === 403 || res.status === 404 || res.status >= 500) {
                        cserr.setErrmess(res.data.message);
                    } else {
                        cserr.setErrmess(ConstMsg.EG9990001);
                    }
                } else {
                    cserr.setErrmess(ConstMsg.EG9990001);
                }
                setLoadingDone(true);
            }
        );
    }

    //初期値表示
    useEffect(function(){
        if (cnr){
            if (cnr.data.name){
                const tmpName = cnr.data.name.split(" ");
                uf.setValue(FORM_NAME_LAST, tmpName[0]);
                uf.setValue(FORM_NAME_FIRST, tmpName[1]);
            }
            if (cnr.data.tel){uf.setValue(FORM_NAME_PHONE, cnr.data.tel)}
            if (cnr.data.email){uf.setValue(FORM_NAME_EMAIL, cnr.data.email)}
            if (cnr.data.birthday){
                const tmpYear = cnr.data.birthday.split("年")[0];
                const tmpMoth = cnr.data.birthday.split("年")[1].split("月")[0];
                const tmpDay = cnr.data.birthday.split("年")[1].split("月")[1].replace("日", "");
                uf.setValue(FORM_NAME_BIRTHDAY_YEAR, tmpYear);
                uf.setValue(FORM_NAME_BIRTHDAY_MONTH, tmpMoth);
                uf.setValue(FORM_NAME_BIRTHDAY_DAY, tmpDay);
            }
            //予約情報に規約同意は保持していないため、名前があれば既に患者情報登録を通過したものとする
            if (cnr.data.name){uf.setValue(FORM_NAME_RULE_AGREE, true)};
        }
        // ufを更新するため第2引数から除外する
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[cnr]);

    return (
        <>
            <ReservationFlow currentProcess={ProcessName.Patient}/>
            <ContentsBox>
                <ReservationInfo />
            </ContentsBox>
            <ContentsBox>
                <ContentsTitle title="患者様情報を入力してください" />
                {errmess && <MsgBoxErr text={errmess} />}
                <LoadingBox overlay={true} loadingDone={loadingDone}>
                    <FormBox useForm={uf} successFunc={FormSubmit} >
                        <TxtName nameLastName={FORM_NAME_LAST} nameFirstName={FORM_NAME_FIRST} />
                        <TxtTel name={FORM_NAME_PHONE} />
                        {ccsi.data.display.patientEmail &&
                            <TxtEmail name={FORM_NAME_EMAIL} />
                        }  
                        {ccsi.data.display.birthday &&
                            <SltBirthday nameYear={FORM_NAME_BIRTHDAY_YEAR} nameMonth={FORM_NAME_BIRTHDAY_MONTH} nameDate={FORM_NAME_BIRTHDAY_DAY} />
                        }
                        {ccsi.data.display.patientEmail &&
                            <NotesMail />
                        }
                        <ChkRuleAgree name={FORM_NAME_RULE_AGREE}/>
                        <BtnSubmit title="次へ" />
                    </FormBox>
                </LoadingBox>
            </ContentsBox>
            <BtnReturn />
        </>
    );

}